import { Enum, Static } from '@sinclair/typebox';

export const CurrencyCode = Enum({
  USD: 'USD',
  CAD: 'CAD',
  JPY: 'JPY',
  SEK: 'SEK',
  DKK: 'DKK',
  NOK: 'NOK',
  EUR: 'EUR',
  GBP: 'GBP',
  AUD: 'AUD',
  CNY: 'CNY',
  HKD: 'HKD',
  PLN: 'PLN',
  RUB: 'RUB',
  SGD: 'SGD',
  CHF: 'CHF',
  THB: 'THB',
  KRW: 'KRW',
});

export type CurrencyCode = Static<typeof CurrencyCode>;
